export const softwareTestingPara = [
    "IStellar have well-trained and highly experienced testers who can help you to streamline your QA process and help your engineering team to provide robust test/QA support. We used the best testing tools and advanced technology to deliver highly effective web application testing services.",
    "Software Testing services perfectly engineered for your Continuous Delivery and DevOps success. We are not only build quality but also create value by preventing defects before they occur.",
    "We are familiar with following modern testing framework, test runner and testing utilities,",
]
export const Contact = [
"If you have small ad-hoc task or bigger team project or your dream product idea in software development ( .NET Core / WebAPI / C# / AWS / Azure ), please don't hesitate to keep in touch with us.",
"To discuss about our software development expertise and services, please mail us on business@istellar.com or call +1 (817) 606-6969 / +91 6969696969",
]
export const dualListItems = [
    {
        listHead: "Testing framework, utilities and Test runner:",
        ul: [
        {li: "Mocha"},
        {li: "Jest"},
        {li: "Enzyme"},
        {li: "Chai"},
        {li: "Should"},
        ]
    }, {
        listHead: "For Automation Testing:",
        ul: [
        {li: "TestCafe"},
        {li: "TestBox"},
        {li: "Selenium"},
    ]
}
]
export const testingServices = [
    {
        h6: "Usability Testing",
        para: "IStellar team verifies how convenient your web application, website is for end users, identifies usability issues and provides on improvements to help you deliver a product that fulfill your target audience usability expectations."
    }, {
        h6: "Functional testing",
        para: "Our Team looks whether your web application works as per the business requirements and report on identified issues."
    }, {
        h6: "Performance testing",
        para: "We test if your web application works under any planned load, stress, scalability and reliability issues in your solution."
    }, {
        h6: "Compatibility testing",
        para: "We verify if your web app or website cleanly works in various environments: For example, on different operating systems and on different devices (laptops, tablets, mobile devices and so on), in different browsers, and so on."
    }, {
        h6: "Compliance Testing",
        para: "We make sure that your web solution works according to the standards of the industry you operate in."
    }, {
        h6: "Web Security Testing",
        para: "With 10 years in information security, we do penetration testing and source code review. Simulating a hacking attack and verify your web solution behavior in such conditions, we help you to focus security vulnerabilities as early as possible."
    }, {
        h6: "Web Testing Automation",
        para: "Our web testing experts ensure high quality and improved performance of your web solution with our best practices in testing automation. We automate functional, performance and regression testing with data-driven and keyword-driven approaches."
    }, 
]